module.exports = __webpack_public_path__ + "static/media/2.81385dd6.png";